import React,{useEffect, useContext} from 'react'
import {  Link } from "react-router-dom";
import { useLocation } from 'react-router-dom'
import { AuthContext } from './../AuthContext';
import { isStaffUser } from './../role.js';

export default function Index() {
  const location = useLocation();
  const { fulluser } = useContext(AuthContext);
  const staffLogin = isStaffUser(fulluser);
  useEffect(() => {
    console.log(location.pathname);
  },[]);
    return (
    <div className="appBottomMenu">
    <Link to="/home" className={`item  ${((location.pathname == '/home' || location.pathname == '/TodaySales') && 'active')}`}>
      <div className="col">
        <ion-icon name="pie-chart-outline" />
        <strong>Overview</strong>
      </div>
    </Link>
    {staffLogin ? (
    <Link to="/StaffReport" className={`item  ${(location.pathname == '/StaffReport' && 'active')}`}>
      <div className="col">
      <ion-icon name="bar-chart-outline"></ion-icon>
        <strong>My Report</strong>
      </div>
    </Link>
    ) : (
    <Link to="/Staff" className={`item  ${(location.pathname == '/Staff' || location.pathname == '/StaffReport') ? 'active' : ''}`}>
      <div className="col">
      <ion-icon name="people-outline"></ion-icon>
        <strong>Staff</strong>
      </div>
    </Link>
    )}
    
    <Link to="/Transaction" className={`item  ${(location.pathname == '/Transaction' && 'active')}`}>
      <div className="col">
        <ion-icon name="card-outline" />
        <strong>My Transaction</strong>
      </div>
    </Link>
    <Link to="/Settings" className={`item  ${(location.pathname == '/Settings' && 'active')}`}>
      <div className="col">
        <ion-icon name="settings-outline" />
        <strong>Settings</strong>
      </div>
    </Link>
  </div>
  
  )
}
